import { TProps } from '../../types/redux/props';
import { TReduxActions } from '../../types/redux';
import { EGetComparisonStatus } from '../../actions/compare';

export const defaultPropsState: TProps = {
  default: [],
  differences: [],
};

export function propsReducer(state: TProps = defaultPropsState, action: TReduxActions): TProps {
  switch (action.type) {
    case EGetComparisonStatus.Succeed: {
      const { props } = action.payload;

      return {
        ...state,
        ...props,
      };
    }
    default:
      return state;
  }
}
